import React from 'react';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large'; // Optional prop for spinner size
}

const Loading: React.FC<LoadingSpinnerProps> = ({ size = 'medium' }) => {
  const getSizeClass = () => {
    switch (size) {
      case 'small':
        return 'w-6 h-6';
      case 'large':
        return 'w-12 h-12';
      default:
        return 'w-8 h-8'; // Default to medium size
    }
  };

  return (
    <div className="flex justify-center items-center">
      <div
        className={`animate-spin rounded-full border-t-2 border-b-2 border-gray-900 ${getSizeClass()}`}
      ></div>
    </div>
  );
};

export default Loading;
